import React from "react";
import { fmtEUR } from "@/lib/format";
import { Badge } from "@/components/ui/badge";
import { Receipt, Info } from "lucide-react";

const REGIME_STYLE = {
  binnenlands: "text-emerald-700 border-emerald-300 bg-emerald-50",
  eu_verlegd: "text-blue-700 border-blue-300 bg-blue-50",
  export: "text-amber-700 border-amber-300 bg-amber-50",
};

export function BtwOverzicht({ result, compact = false }) {
  if (!result) return null;
  const { regime, regime_label, toelichting, land, subtotaal, btw_per_tarief = [], btw_totaal, totaal_incl } = result;

  return (
    <div className="space-y-3" data-testid="btw-overzicht">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2 text-sm font-medium">
          <Receipt className="h-4 w-4 text-muted-foreground" /> BTW-overzicht
        </div>
        <Badge variant="outline" className={REGIME_STYLE[regime] || ""} data-testid="btw-regime-badge">
          {regime_label}
        </Badge>
      </div>

      <div className="text-xs text-muted-foreground">Land klant: <span className="text-foreground">{land || "Nederland"}</span></div>

      <div className="space-y-1.5 text-sm">
        <div className="flex justify-between">
          <span className="text-muted-foreground">Subtotaal (excl. BTW)</span>
          <span className="tabular-nums" data-testid="btw-subtotaal">{fmtEUR(subtotaal)}</span>
        </div>
        {btw_per_tarief.map((t) => (
          <div key={t.tarief} className="flex justify-between text-muted-foreground">
            <span>BTW {t.tarief}% over {fmtEUR(t.grondslag)}</span>
            <span className="tabular-nums">{fmtEUR(t.btw)}</span>
          </div>
        ))}
        <div className="flex justify-between border-t border-border pt-1.5">
          <span className="text-muted-foreground">Totaal BTW</span>
          <span className="tabular-nums" data-testid="btw-totaal">{fmtEUR(btw_totaal)}</span>
        </div>
        <div className="flex justify-between font-medium text-base pt-1">
          <span>Totaal incl. BTW</span>
          <span className="tabular-nums" data-testid="btw-totaal-incl">{fmtEUR(totaal_incl)}</span>
        </div>
      </div>

      {toelichting && !compact && (
        <div className="flex items-start gap-1.5 text-xs text-muted-foreground bg-secondary/50 rounded-md px-2.5 py-2">
          <Info className="h-3.5 w-3.5 mt-0.5 shrink-0" /> {toelichting}
        </div>
      )}
    </div>
  );
}
